
import { computed } from 'vue'
import { useRoute } from 'vue-router';
import type { Ref } from 'vue'


export function useNavTracker(navItems : Ref<Array<any>>, level : Number) {
    const route = useRoute();

    const trackedItems = computed(()=>{
        const path = route.path;
        const split = path.split('/');
        const matchName = split[level];

        return navItems.value.map(item =>{
            item.class =  item.text.toLowerCase() == matchName ? "nav-link router-link-active" : "nav-link router-link";
            return item;
        })
    })

 
    return { trackedItems }
}